module.exports = __webpack_public_path__ + "img/temp-banner-disclaimer.63fd3476.jpg";